import * as React from 'react';
import './recaptcha.scss';
import { Action } from 'redux';
import { LocalConfig } from '../../constants/localConfig';
import { recaptchaV2Submitted } from '../../../common/actions/recaptchaActions';
import { connect } from 'react-redux';

export interface RecaptchaProps {
  config: LocalConfig;
  recaptchaV2Submitted(token: string): Action;
}

export const executeCaptchaV3 = (sitekey: string, action: string): Promise<string> => {
  return window.grecaptcha.execute(sitekey, {
    action: action
  });
};

export const executeCaptchaV2 = (): Promise<string> => {
  return window.grecaptcha.execute();
};

export const resetCaptcha = () => {
  try{
    if (window.grecaptcha) {
      return window.grecaptcha.reset();
    }
  }
  catch(error) {
    // don't block for error.
  }
};

export class ReCaptcha extends React.PureComponent<RecaptchaProps> {
  private scriptV3: HTMLScriptElement;
  private scriptV2: HTMLScriptElement;

  getV3Script = () => {
    return this.scriptV3;
  }

  getV2Script = () => {
    return this.scriptV2;
  }

  componentDidMount(): void {
    this.loadScripts();

    window.recaptchaV2Submitted = (token: string) => {
      this.props.recaptchaV2Submitted(token);
    };
  }

  componentWillUnmount(): void {
    if (this.scriptV3) {
      document.body.removeChild(this.scriptV3);
    }
    document.body.removeChild(this.scriptV2);
  }

  render(): React.ReactNode {
    const useTestKey =
      window.location.href.includes(`passive.${this.props.config.onlineUrl}`)
      || window.location.href.startsWith(`${this.props.config.onlinePaymentsUiADO}`)
      // Add check for localhost for this to allow local E2E to pass.
    return (
      <div
        id="g-recaptcha"
        className="g-recaptcha"
        data-size="invisible"
        data-sitekey={useTestKey ? this.props.config.recaptchaV2TestSiteKey : this.props.config.recaptchaV2SiteKey}
        data-callback="recaptchaV2Submitted"
        data-badge="bottomleft"></div>
    );
  }

  private loadScripts = (): void => {
    this.scriptV2 = document.body.appendChild(this.buildV2Script());
    //this.scriptV3 = document.body.appendChild(this.buildV3Script());
  }

  private buildV2Script = () => {
    const url = 'https://www.google.com/recaptcha/api.js'
    return this.buildScript(url);
  }

  private buildV3Script = () => {
    const url = 'https://www.google.com/recaptcha/api.js'
    const queryString = `?render=${this.props.config.recaptchaSiteKey}`
    return this.buildScript(url + queryString);
  }

  private buildScript = (src: string) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    return script;
  }
}

const mapDispatchToProps = dispatch => ({
  recaptchaV2Submitted: (token: string) => dispatch(recaptchaV2Submitted(token))
});

export default connect(null, mapDispatchToProps)(ReCaptcha);
